module.exports = __webpack_public_path__ + "static/img/nocoo.1b55689.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coo/nocoo.png
// module id = cAwj
// module chunks = 2